import React from "react";
import styles from './EvaluationCard.module.scss';
import EvaluationProgress from "../evaluationProgress/EvaluationProgress";
import {ReactComponent as ChevronIcon} from './Chevron.svg';
import PropTypes from "prop-types";

const EvaluationCard = ({
  data,
  count,
  onClick,
  disabled = false
}) => {
  return (
    <div className={`${styles.card}${disabled ? ` ${styles.disabled}` : ''}`} onClick={disabled ? undefined : onClick}>
      <div className={styles.data}>
        {data.map((item) => (
          <div className={styles.dataItem} key={item.label}>
            <label>{item.label}</label>
            <span className={styles.textRow}>
              <span className={item.color && styles[item.color] ? styles[item.color] : ''}>
                {item.text}
              </span>
              {item.tag && <span className={styles.tag}>{item.tag}</span>}
            </span>
          </div>
        ))}
      </div>
      <div className={styles.chart}>
        <EvaluationProgress {...count} />
        <ChevronIcon />
      </div>
    </div>
  );
};

EvaluationCard.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      color: PropTypes.oneOf(['red', 'green']),
    })
  ).isRequired,
  count: PropTypes.shape({
    total: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired
  }),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

export default EvaluationCard;